import Vue from 'vue'
import Router from 'vue-router'
const Login = () => import('@/views/login/index.vue')
const Register = () => import('@/views/register/index.vue')
const Main = () => import('@/views/main.vue')
const Home = () => import('@/views/home/index.vue')
const Blank = () => import('@/views/blank/index.vue')

const Zijin = () => import('@/views/home/zijin.vue')
const Yaoqing = () => import('@/views/home/yaoqing.vue')
const Zhanghao = () => import('@/views/home/zhanghao.vue')

const Language = () => import('@/views/language/index.vue')
const Zichan = () => import('@/views/zichan/index.vue')
const Recharge = () => import('@/views/zichan/recharge.vue')
const Withdraw = () => import('@/views/zichan/withdraw.vue')
const Record = () => import('@/views/zichan/record.vue')
const User = () => import('@/views/zichan/user.vue')
const Dating = () => import('@/views/dating/index.vue')
const Description = () => import('@/views/home/description.vue')
const Trade = () => import('@/views/dating/trade.vue')
const TradeRecord = () => import('@/views/dating/tradeRecord.vue')
const Setting = () => import('@/views/zichan/set.vue')
const EnterView = { render: h => h('router-view') }

Vue.use(Router)

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      component: Register
    },
    {
      path: '/blank',
      name: 'Blank',
      component: Blank
    },
    {
      path: '/language',
      name: 'Language',
      component: Language
    },
    {
      path: '/zijin',
      name: 'Zijin',
      component: Zijin
    },
    {
      path: '/yaoqing',
      name: 'Yaoqing',
      component: Yaoqing
    },
    {
      path: '/zhanghao',
      name: 'Zhanghao',
      component: Zhanghao
    },
    {
      path: '/recharge',
      name: 'Recharge',
      component: Recharge
    },
    {
      path: '/withdraw',
      name: 'Withdraw',
      component: Withdraw
    },
    {
      path: '/record',
      name: 'Record',
      component: Record
    },
    {
      path: '/user',
      name: 'User',
      component: User
    },
    {
      path: '/description',
      name: 'Description',
      component: Description
    },
    {
      path: '/trade',
      name: 'Trade',
      component: Trade
    },
    {
      path: '/tradeRecord',
      name: 'TradeRecord',
      component: TradeRecord
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting
    },
    {
      path: '',
      component: Main,
      meta: {
        isAuth: true
      },
      children: [
        {
          path: '/home',
          name: 'Home',
          component: Home
        },
        {
          path: '/dating',
          name: 'Dating',
          component: Dating,
        },
        {
          path: '/zichan',
          name: 'Zichan',
          component: Zichan,
        },
      ]
    },
  ]
})

router.beforeEach((to, from, next) => {
  if(to.meta.isAuth) {
    const token = sessionStorage.getItem('token')
    if(token) {
      next()
    }else {
      next({ name: 'Login' })
    }
  }else {
    next()
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js